import { render, staticRenderFns } from "./config-form.vue?vue&type=template&id=1c4b373a"
import script from "./config-form.vue?vue&type=script&lang=ts"
export * from "./config-form.vue?vue&type=script&lang=ts"
import style0 from "./config-form.vue?vue&type=style&index=0&id=1c4b373a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports